import useStyleStore from "src/stores/useStyleStore";

const useStyle = () => {
	const theme = useStyleStore((state) => state.theme);
	return { theme };
};
export default useStyle;
